"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iDistribution = exports.iCreateDistribution = exports.iDistributionRecipient = exports._iDistributionRecipient = void 0;
const t = require("io-ts");
const User = require("./user");
// Create distribution
exports._iDistributionRecipient = t.intersection([
    t.interface({
        quantity: t.number,
        finishing: t.number,
        deliveryMethod: t.number,
        printProvider: t.number,
        uuid: t.string,
        user: User.iAuthor,
        excluded: t.boolean
    }),
    t.partial({
        id: t.number,
        distributionId: t.union([t.null, t.number]),
        distributionName: t.union([t.null, t.string]),
    })
]);
exports.iDistributionRecipient = t.clean(exports._iDistributionRecipient);
exports.iCreateDistribution = t.interface({
    project: t.string,
    name: t.string,
    description: t.string,
    recipients: t.array(exports.iDistributionRecipient)
});
exports.iDistribution = t.interface({
    id: t.number,
    name: t.string,
    project: t.string,
    author: t.union([User.iAuthor, t.null]),
    createdAt: t.union([t.number, t.null]),
    modifiedAt: t.union([t.number, t.null]),
    recipients: t.array(exports.iDistributionRecipient),
    description: t.string
});
//# sourceMappingURL=distribution.js.map